<template>
  <div class="log-order-detail">
    <el-row>
      <p style="font-size:30px">
        <b>Log Order</b>
      </p>
      <el-row>
        <el-col
          :lg="{span:'12' ,offset:'0'}"
          :md="{span:'16' ,offset:'0'}"
          :sm="{span:'16' ,offset:'0'}"
          :xs="{span:'16' ,offset:'0'}"
          style="text-align: left;"
        >
          <div style="margin-top: 15px;margin-bottom: 15px;height:20px">
            <el-input
              placeholder="Order Number"
              v-model="inputOrder"
              class="inputorder"
              @keyup.enter.native="searchOrder"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
            </el-input>
          </div>
        </el-col>
        <el-col
          :lg="{span:'12' ,offset:'0'}"
          :md="{span:'8' ,offset:'0'}"
          :sm="{span:'8' ,offset:'0'}"
          :xs="{span:'8' ,offset:'0'}"
          style="text-align: right;"
        >
          <div style="margin-top: 15px;margin-bottom: 15px;">
            <!-- <el-button @click="$router.push({ path: `/oms/logOrder/logOrderSearch`})" class="inputorder">Back</el-button> -->
                 <el-button type="primary" @click="createShipment()" icon="far fa-file-alt"
                :disabled="(orderDetail.status !== 1 && orderDetail.status !== 2 && orderDetail.status !== 3) || isCourierFlashAndTH"
                > Create Shipment</el-button>
                <el-button
                  type="warning"
                  style="background-color: #E6A23C; border-color: #E6A23C; color: white"
                  @click="onPullStatus(orderDetail)"
                  :disabled="orderDetail.status === 7 || orderDetail.status === 8 || orderDetail.status === 9"
                  plain
                >ดึงสถานะล่าสุด</el-button>
                <el-button
                  type="success"
                  class="log-order-btn-complete"
                  @click="onComplete(orderDetail)"
                  :disabled="orderDetail.status === 7 || orderDetail.status === 8 || orderDetail.status === 9"
                  plain
                >เปลี่ยนสถานะ</el-button>
            <el-button @click="closeTabl()" plain style="height: 43px;">ปิด</el-button>
          </div>
        </el-col>
      </el-row>
      <el-card shadow="never" v-if="showLog">
        <el-col
          :lg="{span:'12' ,offset:'0'}"
          :md="{span:'24' ,offset:'0'}"
          style="text-align: left;"
        >
          <el-card shadow="never" style="margin-bottom: 15px; margin-right:10px">
            <div style="display: flex; flex-flow: row wrap;">
              <div>
                <b style="font-size:24px;margin-right:15px">Order Number : {{orderDetail.orderNumber}}</b>
              </div>
              <div>
                <el-button
                  v-if="$store.get('permission/deleteOrder')"
                  type="danger"
                  class="log-order-btn-delete"
                  @click="onDelete(orderDetail)"
                  :disabled="orderDetail.deletedAt !== null"
                  plain
                >Delete</el-button>
              </div>
            </div>
            Create Shipment at : {{orderDetail.createdShipmentAt ?
            this.$dayjs(orderDetail.createdShipmentAt).format('YYYY-MM-DD HH:mm:ss') : '-'}}
            <br>
            Picked Up At : {{orderDetail.pickedUpAt ?
            this.$dayjs(orderDetail.pickedUpAt).format('YYYY-MM-DD HH:mm:ss') : '-'}}
            <br>
            Courier : {{getCourier(orderDetail.courierId)}}
            <br>
            Payment type : {{getPaymentType(orderDetail.paymentType)}} ({{getPaymentTypeEn(orderDetail.paymentType)}})
            <br>
            Tracking: {{orderDetail.trackingNumber ? orderDetail.trackingNumber : '-'}}
            <br>
            <!-- Link : {{orderDetail.courierId === 1 ? `<a href="https://www.scgexpress.co.th/tracking/detail/${orderDetail.trackingNumber}">link text</a>`:``}}<br> -->
            Link :
            <span v-html="getLink(orderDetail.trackingNumber,orderDetail.courierId)"></span>
            <br>
          </el-card>
          <el-card
            shadow="never"
            style="margin-bottom: 15px; margin-right:15px"
            v-if="orderDetail.courierId === 1"
          >
            <b style="font-size:20px">Tracking History SCG</b>
            <br>
            <el-table :data="TrackingHistory" height="250" style="width: 100%" >
              <el-table-column prop="orderStatus" label="orderStatus">
                <template slot-scope="scope">{{getOrderStatus(scope.row.orderStatus)}}</template>
              </el-table-column>
              <el-table-column prop="scgCode" label="scgCode"></el-table-column>
              <el-table-column prop="statusDate" label="statusDate"></el-table-column>
              <el-table-column prop="statusName" label="statusName"></el-table-column>
            </el-table>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-right:15px">
            <b style="font-size:20px">Shop Detail</b>
            <span v-if="orderDetail.isActivate" style="color:green;">&nbsp;<b>Active</b> </span>
            <span v-else style="color:red;">&nbsp;<b>Deactivate</b></span>
            <span v-if="orderDetail.isApprove" style="color:green;">&nbsp;<b>Approved</b> </span>
            <span v-else style="color:red;">&nbsp;<b>Unapproved</b></span>
            <br>
            Shop Name : {{shopDetail.name}}
            <br>
            Shop Address : {{shopDetail.address}} {{shopDetail.subDistrict}}
            {{shopDetail.district}} {{shopDetail.province}} {{shopDetail.zipcode}}
            <br>
            tel : {{shopDetail.phoneNumber}}
            <br>
            line: {{shopDetail.line ? shopDetail.line : '-'}}
            <br>
            instagram: {{shopDetail.instagram ? shopDetail.instagram : '-'}}
            <br>
            facebook : {{shopDetail.facebook ? shopDetail.facebook : '-'}}
            <br>
            userCode : {{orderDetail.userCode}}
            <br>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-right:15px">
            <b style="font-size:20px;margin-right:10px;">Customer detail</b>
            <!-- <el-button type="primary" size="mini" icon="el-icon-edit" @click="editAddrCustomer"
            :disabled="orderDetail.status !== 1 && orderDetail.status !== 2 "
            ></el-button> -->
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editAddrCustomer"
            :disabled="orderDetail.status !== 1 && orderDetail.status !== 2 && orderDetail.status !== 3"
            ></el-button>
            <br>
            Name : {{orderDetail.shippingName}}
            <br>
            Address : {{orderDetail.shippingAddress}} {{orderDetail.shippingSubDistrict}}
            {{orderDetail.shippingDistrict}} {{orderDetail.shippingProvince}}
            {{orderDetail.shippingZipcode}}
            <br>
            PhoneNumber1 : {{orderDetail.shippingPhoneNumber}}
            <br>
            PhoneNumber2 : {{orderDetail.shippingPhoneNumberSec}}
            <br>
            Tag : {{orderDetail.shippingTag}}
            <br>
            note : {{orderDetail.note}}
            <br>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-right:15px">
            <b style="font-size:20px">Order detail</b>
            <br>
            <b>Order Price : {{orderDetail.netPrice | currency}} ฿</b>
            <br>
            Product Discount total : {{productDiscount.discount | currency}} ฿
            <br>
            Additional Discount : {{orderDetail.additionalDiscount | currency}} ฿
            <br>
            Delivery Cost : {{orderDetail.deliveryCost | currency}} ฿
            <br>
            Weight total : {{WeightTotal | currency}} g
            <br>
            Payment type : {{getPaymentType(orderDetail.paymentType)}}
            ({{getPaymentTypeEn(orderDetail.paymentType)}})
            <br>
            courier : {{getCourier(orderDetail.courierId)}}
            <br>
            Create date : {{this.$dayjs(orderDetail.createdAt).format('YYYY-MM-DD HH:mm:ss')}}
            <br>
            <span v-if="orderDetail.deletedAt">
              Deleted at :{{
              $dayjs(orderDetail.deletedAt).format('YYYY-MM-DD HH:mm:ss')}}
              <br>
            </span>
            <!-- Status : {{getOrderStatus(orderDetail.status)}} ({{getOrderStatusEn(orderDetail.status)}})<br> -->
            Status :
            <span v-html="checkStatus(orderDetail.status,orderDetail.deletedAt)"></span>
            <br>
            Agent : {{orderDetail.agentId ? orderDetail.agentName : '-'}}
            <br>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-right:15px">
            <b style="font-size:20px">Product detail</b>
            <br>
            <el-table :data="productDetail" height="550" style="width: 100%">
              <el-table-column prop="sku" label="Product sku" width="140" fixed></el-table-column>
              <el-table-column prop="name" label="name" width="240"></el-table-column>
              <el-table-column prop="quantity" label="Quantity" width="100"></el-table-column>
              <el-table-column prop="price" label="Price" width="100"></el-table-column>
              <el-table-column prop="discount" label="Discount" width="100"></el-table-column>
              <el-table-column prop="weight" label="Weight" width="100"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col
          :lg="{span:'12' ,offset:'0'}"
          :md="{span:'24' ,offset:'0'}"
          style="text-align: left;"
        >
          <el-card shadow="never" style="margin-bottom: 15px; margin-left:10px;height:500px;">
            <b style="font-size:20px">Order History</b>
            <br>
            <el-table :data="orderDetail.orderHistory" style="width: 100%;" border height="430">
              <el-table-column label="Status" width="70" align="center">
                <template slot-scope="scope">
                  {{getStatus(scope.row)}}

                </template>
              </el-table-column>
              <el-table-column prop="action" label="Action" width="200">
                <template slot-scope="scope">
                  {{scope.row.action}} <br>
                   <span v-if="scope.row.action === 'Status Change'">
                     {{getOrderStatus(scope.row.payload.oldStatus)}} >  {{getOrderStatus(scope.row.payload.status)}}
                  </span>

                </template>
              </el-table-column>
              <el-table-column prop="timestamp" label="At">
                <template
                  slot-scope="scope"
                >{{$dayjs(scope.row.timestamp).format('YYYY-MM-DD HH:mm:ss')}}</template>
              </el-table-column>
              <el-table-column label="By">
                <template slot-scope="scope">
                  <!-- {{scope.row}} -->
                  {{scope.row.editorFirstName}} {{scope.row.editorLastName}}
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type" width="100"></el-table-column>
              <el-table-column prop="type" label width="40">
                <template slot-scope="scope">
                  <i v-if="!scope.row.action.match(/\bStatus Change/)" class="el-icon-info" @click="showDetail(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-left:10px">
            <b style="font-size:20px">Invoice Received</b>
            <br>
          </el-card>
          <el-card shadow="never" style="margin-bottom: 15px; margin-left:10px">
            <b style="font-size:20px">Cs permission</b>
            <br>
            <el-row :gutter="20">
              <el-col :span="24">Note
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder
                  v-model="noteText"
                  :disabled="submitting"
                ></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:20px;">
              <el-col :span="24">Tag
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-tag
                      :key="tag"
                      v-for="tag in dynamicTags"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)"
                    >{{tag}}</el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      v-model="inputValue"
                      ref="saveTagInput"
                      size="mini"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    ></el-input>
                    <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput"
                      :disabled="submitting"
                    >+ New Tag</el-button>
                  </el-col>
                </el-row>
                <hr style="margin-top:20px;">
                <el-row :gutter="20" v-if="isSaved">
                  <el-col :span="24">
                    <el-alert title="order has been saved succesfully" type="success"></el-alert>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top:20px;">
                  <el-col :span="16">
                    <el-button disabled>Edit</el-button>
                    <el-button disabled>Create shipment</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      style="float: right;"
                      type="primary"
                      plain
                      :loading="submitting"
                      @click="saveCsInfo"
                    >{{submitText}}</el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-card>
      <el-card shadow="never" v-if="!showLog">
        <h1>{{message_header}}</h1>
      </el-card>
    </el-row>
    <order-history-datail
      :dialogShow="dialogShopShow"
      @closeModal="dialogShopShow = false"
      :orderHistory="orderHistoryDetailDialog"
    ></order-history-datail>
    <edit-addr
      :dialogShow="dialogEditCustomer"
      @closeModalEditAddr="dialogEditCustomer = false"
      :addrDetail="addrDetail"
      @closeRefresh="createOrder(orderId)"
    ></edit-addr>
    <create-shipment
      :dialogShow="dialogCreateShipment"
      :createShipmentOrderId="createShipmentOrderId"
      @closeModal="dialogCreateShipment = false"
      :CrateShipmentDetail="createShipmentDetail"
      @closeRefresh="createOrder(orderId)"
    ></create-shipment>
    <dialogComplete
      :dialog.sync="dialogComplete"
      ref="dialogComplete"
      @onSuccess="createOrder(orderId)"
    />
    <dialogDelete
      :dialogDelete="dialogDelete"
      @onDeleteSuccess="createOrder(orderId)"
    />
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import orderHistoryDatail from '@/components/LogOrder/OrderHistoryDetail'
import editAddr from '@/components/LogOrder/EditAddrCustomer'
import createShipment from '@/components/LogOrder/CreateShipment'
import dialogComplete from '@/components/LogOrder/DialogComplete'
import dialogDelete from '@/components/LogOrder/DialogDelete'
export default {
    name: 'LogOrderDetail',
    components: {
        orderHistoryDatail,
        editAddr,
        createShipment,
        dialogComplete,
        dialogDelete
    },
    data () {
        return {
            noteText: '',
            orderId: '',
            orderDetail: [],
            inputOrder: '',
            shopDetail: {},
            productDetail: [],
            orderHistoryDetail: [],
            dynamicTags: [],
            showLog: false,
            inputVisible: false,
            inputValue: '',
            isSaved: false,
            submitting: false,
            submitText: 'Submit',
            message_header: '',
            productDiscount: null,
            dialogShopShow: false,
            dialogEditCustomer: false,
            addrDetail: {},
            orderHistoryDetailDialog: {},
            TrackingHistory: [],
            WeightTotal: '',
            dialogCreateShipment: false,
            createShipmentDetail: {},
            env: '',
            dialogComplete: {
                isDialog: false,
                data: {
                    oldStatus: null,
                    orderNumber: null,
                    orderId: null
                }
            },
            dialogDelete: {
                isDialog: false,
                data: {
                    orderNumber: null,
                    orderId: null
                }
            },
            createShipmentOrderId: 0
        }
    },
    computed: {
        isCourierFlashAndTH () {
            return this.orderDetail.trackingNumber.slice(0, 2) === 'TH' && this.orderDetail.courierId === 4
        }
    },
    async created () {
        if (this.$route.query.orderId) {
            await this.createOrder(this.$route.query.orderId)
        }
        this.env = this.$store.get('envSystem/mode')
    },
    methods: {
        async onPullStatus (order) {
            try {
                this.$loading()
                const params = {
                    orders: [
                        {
                            orderNumber: order.orderNumber,
                            trackingNumber: order.trackingNumber,
                            courierId: order.courierId
                        }
                    ] }
                let response = await fgApi.courier.pullStatusOrderList(params)
                if (response.success) {
                    this.$message.success('ดึงสถานะล่าสุดสำเร็จ!!')
                    this.fetchOrderDefail()
                }
                this.$loading().close()
            } catch (error) {
                console.error(error)
            }
        },
        async fetchOrderDefail () {
            let orderNumber = this.orderId.trim()
            try {
                let res = await fgApi.order.getOrderLogByOrderNumber({
                    search_number: orderNumber
                })
                if (res.success) {
                    this.showLog = true
                    this.orderDetail = res.data
                    this.shopDetail = res.data.shop
                    this.productDetail = res.data.products
                    this.noteText = res.data.csNote
                    this.dynamicTags = res.data.tag
                    if (this.productDetail) {
                        this.productDiscount = this.productDetail.reduce((sum, number) => ({
                            discount: sum.discount + number.discount,
                            weight: sum.weight + number.weight
                        }))
                        let WeightTotal = this.productDetail.map(el => {
                            return el.weight * el.quantity
                        })
                        this.WeightTotal = WeightTotal.reduce(
                            (accumulator, currentValue) => accumulator + currentValue
                        )
                    }
                    if (this.dynamicTags == null) {
                        this.dynamicTags = []
                    }
                    if (this.orderDetail.courierId === 1) {
                        try {
                            let logHis = await fgApi.courier.getTrackingHistory({
                                order_number: orderNumber,
                                courier_id: this.orderDetail.courierId
                            })
                            this.TrackingHistory = logHis.data
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.message_header = res.message
                }
            } catch (error) {
                console.log(error)
            }
        },
        async searchOrder () {
            this.showLog = false
            this.$router.push({
                path: `/oms/logOrder/LogOrderDetail`,
                query: {
                    orderId: this.inputOrder
                }
            })
            this.createOrder(this.inputOrder)
        },
        async createOrder (orderId) {
            this.$loading()
            if (orderId) {
                this.orderId = orderId
                this.inputOrder = orderId
                await this.fetchOrderDefail()
            } else {
                console.log('no orderId')
            }
            this.$loading().close()
        },
        handleClose (tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
        },
        showInput () {
            this.inputVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm () {
            let inputValue = this.inputValue
            if (inputValue) {
                this.dynamicTags.push(inputValue)
            }
            this.inputVisible = false
            this.inputValue = ''
        },
        async saveCsInfo () {
            this.submitting = true
            await fgApi.order.updateOrderCsInfo({
                orderNumber: this.orderId,
                csNote: this.noteText,
                tag: this.dynamicTags
            })
            this.searchOrder()
            this.isSaved = true
            this.submitting = false
        },
        showDetail (data) {
            this.dialogShopShow = true
            this.orderHistoryDetailDialog = data
        },
        closeTabl () {
            window.close()
        },
        getLink (tkNumber, courierId) {
            if (tkNumber) {
                if (courierId === 1) {
                    // SCG
                    return `<a target="_blank" href='https://www.scgexpress.co.th/tracking/?tracking_search=${tkNumber}'>${tkNumber}</a>`
                } else if (courierId === 4) {
                    // FLASH
                    return `<a target="_blank" href='https://www.flashexpress.co.th/tracking?se=${tkNumber}'>${tkNumber}</a>`
                } else if (courierId === 9) {
                    return `<a target="_blank" href='https://www.best-inc.co.th/track?bills=${tkNumber}'>${tkNumber}</a>`
                } else if (courierId === 10) {
                    return `<a target="_blank" href='https://www.bee-express.com/waybill?id=${tkNumber}'>${tkNumber}</a>`
                } else {
                    return '-'
                }
            }
            return tkNumber
        },
        checkStatus (status, del) {
            // {{getOrderStatus(item.status)}}
            let statusNameEN = this.getOrderStatusEn(status)
            let statusName = this.getOrderStatus(status)
            if (del) {
                return `<span style="color:red;">${statusName} (${statusNameEN}) (ลบ)<span>`
            } else {
                return `${statusName} (${statusNameEN})`
            }
        },
        editAddrCustomer () {
            this.addrDetail = {
                addr: this.orderDetail.shippingAddress,
                province: this.orderDetail.shippingProvince,
                district: this.orderDetail.shippingDistrict,
                subdistrict: this.orderDetail.shippingSubDistrict,
                zipcode: this.orderDetail.shippingZipcode,
                order_number: this.orderDetail.orderNumber,
                note: this.orderDetail.note,
                orderDetail: this.orderDetail
            }
            this.dialogEditCustomer = !this.dialogEditCustomer
        },
        createShipment () {
            if (this.orderDetail.isActivate && this.orderDetail.isApprove) {
                this.createShipmentDetail = {
                    order_numbers: [String(this.orderDetail.orderNumber)],
                    shop_id: this.shopDetail.shopId,
                    status: 3,
                    trackingNumber: this.orderDetail.trackingNumber,
                    courierId: this.orderDetail.courierId,
                    orderHistory: this.orderDetail.orderHistory
                }
                this.createShipmentOrderId = this.orderDetail.orderId
                this.dialogCreateShipment = !this.dialogCreateShipment
            } else {
                this.$alert('ร้านค้าไม่ได้ Activate และ Approve', 'แจ้งเตือน', {
                    confirmButtonText: 'ปิด',
                    type: 'warning',
                    center: true,
                    callback: action => {

                    }
                })
            }
        },
        getStatus (row) {
            if (row.action === 'Create shipment') {
                if (row.payload.success === true) {
                    return 'Passed'
                } else {
                    return 'Failed'
                }
            } else if (row.action === 'Update shipment') {
                if (row.payload.success === true) {
                    return 'Passed'
                } else {
                    return 'Failed'
                }
            } else {
                return '-'
            }
        },
        onComplete ({ orderNumber, status, orderId }) {
            this.$refs.dialogComplete.selectId = null
            this.$refs.dialogComplete.note = ''

            this.dialogComplete.isDialog = !this.dialogComplete.isDialog
            this.dialogComplete.data.oldStatus = status
            this.dialogComplete.data.orderNumber = orderNumber
            this.dialogComplete.data.orderId = orderId
        },
        onDelete ({ orderNumber, orderId }) {
            this.dialogDelete.isDialog = !this.dialogDelete.isDialog
            this.dialogDelete.data.orderNumber = orderNumber
            this.dialogDelete.data.orderId = orderId
        }
    }
}
</script>

<style lang="scss">
.log-order-detail {
  .text-size {
    font-size: 16px;
  }

  .inputorder {
    .el-input__inner {
      font-size: 20px;
      height: 50px;
    }

    span {
      font-size: 16px;
      height: 50px;
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .savedText {
    display: table;
    text-align: center;
  }

  .el-icon-info {
    cursor: pointer;
  }

  .log-order-btn-complete {
    background-color: #1d8649;
    color: white;
    height: 43px;
    border-color: #1d8649;
  }

  .el-button--success:hover {
    background-color: #18ad57;
    border-color: #18ad57;
  }

  .log-order-btn-delete {
    background-color: #de0000;
    color: white;
    height: 43px;
    border-color: #de0000;
  }

  .el-button--danger:hover {
    background-color: #f73434;
    border-color: #f73434;
  }

}
</style>
